import React from 'react';
import { Link } from 'react-router-dom';
import { PageSettings } from './../../config/page-settings.js';
import Countdown, { doubleDigit } from "react-downcount";

class Welcome extends React.Component {
	static contextType = PageSettings;

	constructor(props) {
		super(props);
		this.endDate = Date.now() + 1000 * 60 * 60 * 240;
	}

	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetBodyWhiteBg(true);
		this.context.handleSetPageContentClass('p-0');
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetPageContentClass('');
		this.context.handleSetBodyWhiteBg(false);
	}

	render() {
		return (
			<div className="coming-soon">
				<div className="coming-soon-header">
					<div className="bg-cover"></div>
					<div className="brand">
						<span className="logo"></span> <b>Artajasa</b> SBMS
					</div>
					<div className="desc">
						Our website is almost there and it’s rebuilt from scratch! A lot of great new features <br />and improvements are coming.
					</div>
				</div>
				<div className="coming-soon-content d-flex flex-column justify-content-center">
					<div className="desc">
						We are launching a closed <b>beta</b> soon!<br /> Sign up to try it before others and be the first to know when we <b>launch</b>.
					</div>
          <div className="d-flex justify-content-around align-self-center" style={{width: "20%", marginBottom: 20}}>
						<Link
							to={{
								pathname: `/user/form-visitor`,
								state: {
									visitorType: '1'
								}
							}}
            ><button type="button" className="btn btn-success">Tamu</button></Link>
            <Link to="/user/form-staff"><button type="button" className="btn btn-purple">Pegawai</button></Link>
          </div>
					<p>
						Follow us on
						<Link to="/extra/coming-soon" className="text-inverse"><i className="fab fa-twitter fa-lg fa-fw text-info"></i> Twitter</Link> and
						<Link to="/extra/coming-soon" className="text-inverse"><i className="fab fa-facebook fa-lg fa-fw text-primary"></i> Facebook</Link>
					</p>
				</div>
			</div>
		)
	}
}

export default Welcome;
